import { ShareableSecretResponse } from '@electricjs/core_entity-client';

import { simpleOrganization } from '@/mocks/data/organizationData';
import { simpleEmployee, storefrontEmployee1 } from '@/mocks/data/employeeData';

const sharedFields = {
  organization_id: simpleOrganization.id,
  application_slug: '1password',
  password: 'Xp9#mK2$vLqR7nWt',
  backup_codes: [
    '7842-fkrj-9xqp-2mnt-bsdw',
    'a3f1-ztqm-8ryv-6ckp-nxjh',
    'b9d4-hwse-2lpq-7vgt-ymcr',
    'c5k8-urbn-4xwj-3fds-qtiz',
    'e2p6-mjvl-1chy-9ong-wkxa',
  ],
};

// employee_id matches the mock logged user → shows "Your sign-in details" view
export const mockOwnShareableSecret: ShareableSecretResponse = {
  ...sharedFields,
  employee_id: simpleEmployee.id,
};

// employee_id is a different employee → shows "Sign-in details for …" view
export const mockOtherShareableSecret: ShareableSecretResponse = {
  ...sharedFields,
  employee_id: storefrontEmployee1.id,
};

// ↓ Switch between the two variants here to test both views
export const mockShareableSecret = mockOwnShareableSecret;
